import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Gravatar from 'react-gravatar';
import { withTranslation } from 'react-i18next';
// @material-ui/icons
import ExitToApp from '@material-ui/icons/ExitToApp';
import Dehaze from '@material-ui/icons/Dehaze';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Hidden } from '@material-ui/core';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import styles from 'assets/jss/Layout';
import { getUserPhotoUrl } from 'helpers/functions';

class Logged extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: null,
    };
  }

  /**
   * @description
   * To show the menu
   * @param {Object} evt - Event.
   */
  openSubmenu = evt => {
    this.setState({ open: evt.currentTarget });
  };

  /**
   * @description
   * To hide the menu
   */
  handleClose = () => {
    this.setState({ open: null });
  };

  /**
   * @description
   * For close the menu after option selected
   * @returns {*} Nothing.
   */
  handleChangeLanguage = () => {
    const { changeLanguage } = this.props;
    changeLanguage();
    this.handleClose();
  };

  /**
   * @description
   * For close the menu after option selected
   * @returns {*} Nothing.
   */
  handleViewProfile = () => {
    const { viewProfile } = this.props;
    viewProfile();
    this.handleClose();
  };

  render() {
    const { user, logout, classes, t } = this.props;
    const { open } = this.state;
    return (
      <div className={classes.alignmentUser}>
        <GridContainer justify="flex-end">
          <GridItem>
            <div className={classes.user}>
              {user.photo ? (
                <img
                  className={classes.avatar}
                  src={getUserPhotoUrl(user.photo)}
                  alt="Avatar"
                />
              ) : (
                <Gravatar
                  className={classes.avatar}
                  email={user.email || user.fullname}
                />
              )}
              <div>
                <p className={classes.userName}>{user.fullname}</p>
                <p>{user.rank}</p>
              </div>
            </div>
          </GridItem>
          <GridItem>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
              <Button
                id="languageButton"
                simple
                color="primary"
                onClick={() => this.handleChangeLanguage()}
              >
                {t('common.language')}
              </Button>
              <Button id="logoutButton" simple color="primary" onClick={logout}>
                <ExitToApp />
                {t('common.session')}
              </Button>
            </Hidden>
            <Hidden only={['xs']}>
              <Button
                aria-owns={open ? 'menu-dropdown' : undefined}
                aria-haspopup="true"
                onClick={this.openSubmenu}
                simple
                justIcon
                color="primary"
                id="openDropdownMenu"
              >
                <Dehaze />
              </Button>
              <Menu
                id="menu-dropdown"
                anchorEl={open}
                open={Boolean(open)}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.handleViewProfile}>
                  {t('common.profile')}
                </MenuItem>
                <MenuItem divider onClick={() => this.handleChangeLanguage()}>
                  {t('common.language')}
                </MenuItem>
                <MenuItem id="menuCloseSession" onClick={logout}>
                  <ExitToApp />
                  {t('common.session')}
                </MenuItem>
              </Menu>
            </Hidden>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * Logged PropTypes
 * @param classes - prop styles received from withStyles
 * @param user - prop user info received from parents
 * @param t - prop from HOC with string translations
 * @callback logout - callback called when click logout button
 */

Logged.propTypes = {
  user: PropTypes.shape({}).isRequired,
  logout: PropTypes.func.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  viewProfile: PropTypes.func.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(styles)(Logged));
